module.exports = __webpack_public_path__ + "img/slot-machine-background.6efdf89b.svg";